import { render, staticRenderFns } from "./CrossList.vue?vue&type=template&id=d42a2326&scoped=true&"
import script from "./CrossList.vue?vue&type=script&lang=js&"
export * from "./CrossList.vue?vue&type=script&lang=js&"
import style0 from "./CrossList.vue?vue&type=style&index=0&id=d42a2326&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d42a2326",
  null
  
)

export default component.exports